export const PRICE_INCREASE_EFFECTIVE_DATE = new Date(2026, 8, 27);
export const PRICE_INCREASE_NOTICE_DATE = "September 26, 2026";
export const ADDITIONAL_PRICE_INCREASE_EFFECTIVE_DATE = new Date(2026, 8, 29);

const PRICE_INCREASE_MULTIPLIER = 1.1;

export function isPriceIncreaseActive(date = new Date()): boolean {
    return date >= PRICE_INCREASE_EFFECTIVE_DATE;
}

export function getScheduledPriceAmount(amount: number, date = new Date()): number {
    const scheduledAmount = isPriceIncreaseActive(date)
        ? Math.round(amount * PRICE_INCREASE_MULTIPLIER)
        : amount;

    return date >= ADDITIONAL_PRICE_INCREASE_EFFECTIVE_DATE
        ? Math.round(scheduledAmount * PRICE_INCREASE_MULTIPLIER)
        : scheduledAmount;
}

export function extractPriceAmount(price: string): number {
    return Number(price.replace(/[^\d]/g, ""));
}

export function formatPrice(amount: number, suffix = ""): string {
    return `₹${amount.toLocaleString("en-IN")}${suffix}`;
}

function getPriceSuffix(price: string): string {
    return price.includes("/-") ? " /-" : "";
}

export function getPriceView(
    price: string,
    discountActive = false,
    discountMultiplier = 0.7
) {
    const scheduledAmount = getScheduledPriceAmount(extractPriceAmount(price));
    const finalAmount = discountActive
        ? Math.round(scheduledAmount * discountMultiplier)
        : scheduledAmount;
    const suffix = getPriceSuffix(price);

    return {
        originalText: formatPrice(scheduledAmount, suffix),
        finalText: formatPrice(finalAmount, suffix),
        amount: finalAmount,
    };
}
